module.exports = __webpack_public_path__ + "static/3-68e9507a85edbd84722605b5f0e84962.jpg";